import React, { Component, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import "./index.css";
import loadingGif from "./assets/loading.gif"
import Loader from "./features/loader/Loader";
import CanonicalUrl from "./components/CanonicalUrl";
import AddManager from "./features/userAccess/AddManager";
import AddAgent from "./features/userAccess/AddAgent";
import UserList from "./features/userAccess/UserList";
import EditManager from "./features/userAccess/EditManager";
import EditAgent from "./features/userAccess/EditAgent";
import HbbHome from "./features/hbb/HbbHome";
import CoverageChecker from "./features/hbb/CoverageChecker";
import HbbDevices from "./features/hbb/HbbDevices";
import BankDetails from "./features/hbb/BankDetails";

// Lazy load components for code splitting
const Home = React.lazy(() => import("./features/home/Home"));
const Login = React.lazy(() => import("./features/login/Login"));
const Register = React.lazy(() => import("./features/login/Register"));
const ProductDetails = React.lazy(() => import("./features/product-details/ProductDetails"));
const Checkout = React.lazy(() => import("./features/checkout/Checkout"));
const Error404 = React.lazy(() => import("./features/error/Error404"));
const ResetPassword = React.lazy(() => import("./features/login/ResetPassword"));
const ForgotPassword = React.lazy(() => import("./features/login/ForgotPassword"));
const ChangePassword = React.lazy(() => import("./features/login/ChangePassword"));
const VerificationResponse = React.lazy(() => import("./features/login/VerificationResponse"));
const VerificationOnly = React.lazy(() => import("./features/login/VerificationOnly"));
const MyOrder = React.lazy(() => import("./features/order/MyOrder"));
const Dashboard = React.lazy(() => import("./features/dashboard/Dashboard"));
const FreeAsYouGoSim = React.lazy(() => import("./features/free-sim/FreeAsYouGoSim"));
const FreeSimOrder = React.lazy(() => import("./features/free-sim/FreeSimOrder"));
const AcknowledgeContract = React.lazy(() => import("./features/checkout/AcknowledgeContract"));
const CheckoutDirectOrder = React.lazy(() => import("./features/checkout/CheckoutDirectOrder"));
const Cancellation = React.lazy(() => import("./features/cancellation/Cancellation"));
const CancellationConfirmation = React.lazy(() => import("./features/cancellation/CancellationConfirmation"));
const OrderCancellationStatus = React.lazy(() => import("./features/cancellation/OrderCancellationStatus"));
const PrivacyPolicy = React.lazy(() => import("./features/legal/PrivacyPolicy"));
const GKTTnC = React.lazy(() => import("./features/legal/GKTTnC"));
const ThreeTnC = React.lazy(() => import("./features/legal/ThreeTnC"));
const AboutUs = React.lazy(() => import("./features/legal/AboutUs"));
const FAQ = React.lazy(() => import("./features/legal/FAQ"));
const DocumentUpdates = React.lazy(() => import("./features/legal/documentUpdates/DocumentUpdates"));
const SignupContract = React.lazy(() => import("./features/login/SignupContract"));
const VerificationForUserUpdateReq = React.lazy(() => import("./features/login/VerificationForUserUpdateReq"));
const Complaint = React.lazy(() => import("./features/complaint/Complaint"));
const SimOnlyQuery = React.lazy(() => import("./features/legal/SimOnlyQuery"));
const IotDevices = React.lazy(() => import("./features/legal/IotDevices"));
const Blog = React.lazy(() => import("./features/blogs/Blog"));
const BlogDetails = React.lazy(() => import("./features/blogs/BlogDetails"));

const loading = () => (
  <Loader />
);

class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <CanonicalUrl />
        <Suspense fallback={loading()}>
          <Routes>
            <Route path="/" name="Home" element={<Home/>} />
            <Route path="/login" name="Login" element={<Login/>}/>
            <Route path="/register" name="Register" element={<Register />}/>
            <Route path="/productDetails" name="Product Details" element={<ProductDetails/>}/> 
            <Route path="/checkout" name="Checkout" element={<Checkout/>}/> 
            <Route path="/checkout" name="Checkout" element={<Checkout/>}/> 
            <Route path="/forgotPassword/:id" name="Forgot password" element={<ForgotPassword/>}/> 
            <Route path="/login/:id" name="login redirect" element={<VerificationResponse/>}/> 
            <Route path="/register/dealer/:id" name="login redirect" element={<VerificationResponse/>}/> 
            <Route path="/forgotPasswordVerify/:param1/:param2" name="Reset Password" element={<ResetPassword/>}/>
            <Route path="/changePassword" name="Change password" element={<ChangePassword/>}/> 
            <Route path="/verify-only/:id" name="verification only" element={<VerificationOnly />} />  
            <Route path="/myorder" name="My Order" element={<MyOrder />} />  
            <Route path="/myorder/:orderId" name="My Order" element={<MyOrder />} />  
            <Route path="/dashboard" name="Dashboard" element={<Dashboard />} />  
            <Route path="/free-sim" name="Free pay as you go" element={<FreeAsYouGoSim />} />  
            <Route path="/acknowledgeContract/:id1/:id2" name="Acknowledge Contract page" element={<AcknowledgeContract />} />
            <Route path="/free-sim-order" name="Free sim order page" element={<FreeSimOrder />} />  
            <Route path="/free-sim-orderConfirmation" name="Free sim order confirmation page" element={<CheckoutDirectOrder />} />  
            <Route path="/free-sim-orderConfirmation/:id" name="Free sim order confirmation page" element={<CheckoutDirectOrder />} />
            <Route path="/cancellation" name="Cancellation" element={<Cancellation />} />  
            <Route path="/cancel-confirmation" name="Cancel Confirmation" element={<CancellationConfirmation />} />  
            <Route path="/order-cancellation/:verificationId/:orderId" name="Order Cancellation Status" element={<OrderCancellationStatus />} /> 
            <Route path="/privacy-policy" name="Privacy Policy" element={<PrivacyPolicy />} />  
            <Route path="/iot-terms-and-condition" name="GKT terms & condition" element={<GKTTnC />} />  
            <Route path="/three-terms-and-condition" name="Three terms & condition" element={<ThreeTnC />} />  
            <Route path="/about-us" name="About Us" element={<AboutUs />} />  
            <Route path="/faq" name="Frequently Asked Question" element={<FAQ />} />  
            <Route path="/updatedDocument" name="Updated Document" element={<DocumentUpdates />} />  
            <Route path="/signupContract/:id" name="signup contract" element={<SignupContract/>}/> 
            <Route path="/complaint" name="complaint" element={<Complaint/>}/> 
            <Route path="/sim-only-query" name="SIMOnly query" element={<SimOnlyQuery/>}/> 
            <Route path="/acknowledgementFirstAndLastName/:id" name=" Update user req verification" element={<VerificationForUserUpdateReq />} />  
            <Route path="/signupContract/:id" name="signup contract" element={<SignupContract/>}/> 
            <Route path="/iot-devices" name="IOT Devices" element={<IotDevices/>}/> 
            <Route path="/register/:id" name="Customer register" element={<Register/>}/> 
            <Route path="/:referralCode" name="Referral code" element={<Home/>}/> 
            <Route path="/blogs" name="Blogs" element={<Blog/>} />  
            <Route path="/blog/:id" name="Blog Details" element={<BlogDetails/>} />  
            <Route path="/addManager" name="Add Manager" element={<AddManager/>} />  
            <Route path="/addAgent" name="Add Agent" element={<AddAgent/>} />  
            <Route path="/userList" name="User List" element={<UserList/>} />  
            <Route path="/editManager" name="Edit Manager" element={<EditManager/>} />  
            <Route path="/editAgent" name="Edit Agent" element={<EditAgent/>} />  
            <Route path="/hbbHome" name="Home Broadband" element={<HbbHome/>} />  
            <Route path="/coverageChecker" name="Coverage Checker" element={<CoverageChecker/>} />  
            <Route path="/hbbDevices" name="Home Broadband Devices" element={<HbbDevices/>} />  
            <Route path="/bankDetails/:encryptedCreditCheckId/:encryptedUserId" name="Bank Details" element={<BankDetails />} />          </Routes>
        </Suspense>
      </BrowserRouter>
    );
  }
}

export default App;